const baseUrl = 'https://accounts.spotify.com';
const authorizationCode = '/authorize';
const accessToken = '/api/token';

export {
    baseUrl,
    authorizationCode,
    accessToken
}